<template>
  <div class="appointmentList-view">
    <div class="flex-a-b-c">
      <el-button class="v-primary" type="primary" @click="addGoodsType">{{ $t('merchandise', 'newCategory') }}</el-button>
      <div>
        <!-- <el-select v-model="value" placeholder="请选择" style="width: 240px">
          <el-option value="" label="全部" class="cbcc">全部</el-option>
          <el-option
            v-for="item in optionList"
            :key="item.productsTypeId"
            :label="item.productsTypeName"
            :value="item.productsTypeId"
          >
          </el-option>
        </el-select> -->
        <el-input
             v-model="searchKey"
             class="mb10"
             style="width: 240px"
             :placeholder="$t('merchandise', 'inputCategoryName')"
          />
        <el-button class="v-primary ml10" type="primary" @click="queryAppointmentPage">{{ $t('merchandise', 'query') }}</el-button>
      </div>
    </div>

    <commonTable :tableData="tableData"
                 @handleSizeChange="handleSizeChange"
                 @handleCurrentChange="handleCurrentChange"
                 :currentPage="currentPage"
                 :loading="loading"
                 :total="total">
      <template v-slot:table>
        <el-table-column prop="productsTypeId" width="100" align="center" :label="$t('merchandise', 'categoryId')" />
        <el-table-column
          prop="productsTypeName"
          align="center"
          :label="$t('merchandise', 'categoryName')"
          show-overflow-tooltip
        />
        <el-table-column prop="productsCount" align="center" :label="$t('merchandise', 'goodsCount')" />
        <el-table-column align="center" :label="$t('merchandise', 'operation')">
           <template slot-scope="scope">
            <span class="mr10 hover_pointer cblue" @click="editType(scope.row.productsTypeId)">{{ $t('merchandise', 'edit') }}</span>
            <span class="hover_pointer corange" @click="deleteType(scope.row.productsTypeId)">{{ $t('merchandise', 'delete') }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('merchandise', 'sort')">
          <template slot-scope="scope">
            <span class="el-icon-upload2 mr10 hover_pointer" style="font-size:20px" @click="goodsSort('up',scope.row.productsTypeId)" :title="$t('merchandise', 'moveUp')"></span>
            <span class="el-icon-download hover_pointer" style="font-size:20px" @click="goodsSort('down',scope.row.productsTypeId)" :title="$t('merchandise', 'moveDown')"></span>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import {
  fetchProductsTypePage,
  fetchProductsTypeList,
  alterAppointmentGoodsTypeSort,
  addAppointmentGoodsType,
  delProductsType
} from "@/api/companyManage.js";
import { getDataTimeSec } from "@/utils";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  name: "appointmentList",
  components: {
    commonTable,
  },
  data() {
    return {
      userInfo: this.$store.state.loginRoot.userInfo,
      value: "",
      tableData: [],
      optionList:'', //全部分类
      loading:false,
      total: 0, //总条数
      currentPage: 1, //当前页数
      queryDate: "",
      pageNum: 1,
      pageSize: 10,
      searchKey:'' //关键字
    };
  },
  computed: {
    setDataTimeSec() {
      return (data) => getDataTimeSec(data);
    },
  },
  props:{
    jurisdiction:{
        type: Boolean,
        default: false,
    },
  },
  mounted(){
    this.getTableData()
    this.getTypeList()
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods:{
    //请求预约商品列表数据
    getTableData() {
      this.loading = true;
      let data = {
        ignore: true,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        productsTypeId: this.value,
        productsTypeName:this.searchKey
      };
      fetchProductsTypePage(data)
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.pageInfo.list || "";
          this.total = res.data.pageInfo.total;
        })
        .catch((err) => {
          this.loading = false;
          this.tableData = [];
          console.log(err);
        });
    },
    //查询分类
    getTypeList() {
      fetchProductsTypeList({ ignore: true })
        .then((res) => {
          this.optionList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //筛选查询符合条件数据
    queryAppointmentPage() {
      
      this.currentPage = 1;
      this.pageNum = 1;
      this.loading = true;
      this.getTableData();
    },
    //修改排序
    goodsSort(type,id) {
      if(this.userInfo.roleId || this.jurisdiction){
        let data = ''
        if(type == 'up'){
          data = {
            productsTypeId: id,
            type: 1,
          }
        }else{
          data = {
            productsTypeId: id,
            type: 2,
          }
        }
        alterAppointmentGoodsTypeSort(data)
          .then((res) => {
                    this.$message({
          type: "success",
          message: this.$t('merchandise', 'operationSuccess'),
        });
            this.loading = true;
            this.getTableData()
          })
          .catch((err) => {
            console.log(err);
          });
      }else{
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
      
    },
    //新增
    addGoodsType(){
      if(this.userInfo.roleId || this.jurisdiction){
        this.$prompt(this.$t('merchandise', 'addCategory'), this.$t('common', 'info'), {
          confirmButtonText: this.$t('common', 'confirm'),
          cancelButtonText: this.$t('common', 'cancel'),
        })
        .then(({ value }) => {
          let data = {
            productsTypeName: value,
          };
          
          addAppointmentGoodsType(data)
          .then(res=>{
            this.$message({
              type: "success",
              message: res.message,
            });
            this.searchKey = ''
            this.getTableData()
          });

        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "info",
            message: this.$t('merchandise', 'cancelInput'),
          });
        });
      }else{
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
      
    },
    //修改
    editType(id){
      if(this.userInfo.roleId || this.jurisdiction){
        this.$prompt(this.$t('merchandise', 'editCategory'), this.$t('common', 'info'), {
          confirmButtonText: this.$t('common', 'confirm'),
          cancelButtonText: this.$t('common', 'cancel'),

        })
        .then(({ value }) => {
          let data = {
            productsTypeId:id,
            productsTypeName: value,
          };
          addAppointmentGoodsType(data)
          .then(res=>{
            this.$message({
              type: "success",
              message: res.message,
            });
            this.searchKey = ''
            this.getTableData()
          });

        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "info",
            message: this.$t('merchandise', 'cancelInput'),
          });
        });
      }else{
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
      
    },
    //删除
    deleteType(id){
      if(this.userInfo.roleId || this.jurisdiction){
        this.$confirm(this.$t('merchandise', 'deleteCategoryConfirm'), this.$t('common', 'info'), {
          confirmButtonText: this.$t('common', 'confirm'),
          cancelButtonText: this.$t('common', 'cancel'),
          type: 'warning'
        })
        .then(( ) => {
          let data = {
            productsTypeId:id,
          };
          delProductsType(data)
          .then(res=>{
            this.$message({
              type: "success",
              message: res.message,
            });
            this.searchKey = ''
            this.getTableData()
          });

        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "info",
            message: this.$t('merchandise', 'cancelInput'),
          });
        });
      }else{
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
      
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.loading = true;
      this.getTableData();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.currentPage = 1;
      this.loading = true;
      this.getTableData();
    },
  }
};
</script>

<style lang="scss" scoped>
.appointmentList-view {
  background: #ffffff;
  padding: 24px;
}
</style>